import { TGlobalStores } from ".";
import { IModelGroupData } from "../data/modelGroup/modelGroup";
import { BaseListStore } from "./base/baseListStore";

export class ModelGroupStore {
  private _modelGroupMap: BaseListStore<IModelGroupData>;

  constructor(gs: TGlobalStores) {
    this._modelGroupMap = new BaseListStore<IModelGroupData>(gs);
  }

  get modelGroupDatas() {
    return this._modelGroupMap.getList();
  }

  updateModelGroupData(
    modelGroupDataId: string,
    updateParams: Partial<IModelGroupData>,
  ) {
    this._modelGroupMap.frequentlyUpdate(modelGroupDataId, updateParams);
  }

  isModelGroupFuniture(funitureId: string) {
    const modelGroupDatas = this.modelGroupDatas;
    for (const modelGroupData of modelGroupDatas) {
      const findFunitureId = modelGroupData.accessorieIds.find(
        (accessorieId) => accessorieId === funitureId,
      );
      if (findFunitureId) {
        return true;
      }
    }

    return false;
  }

  getRelateModelGroupId(funitureId: string) {
    const modelGroupDatas = this.modelGroupDatas;
    for (const modelGroupData of modelGroupDatas) {
      const findFunitureId = modelGroupData.accessorieIds.find(
        (accessorieId) => accessorieId === funitureId,
      );
      if (findFunitureId) {
        return modelGroupData.id;
      }
    }

    return undefined;
  }

  getModelGroupData(modelGroupId: string) {
    return this._modelGroupMap.get(modelGroupId);
  }

  addModelGroupData(modelGroupData: IModelGroupData) {
    this._modelGroupMap.add(modelGroupData);
  }

  removeModelGroupDataById(modelGroupId: string) {
    this._modelGroupMap.remove(modelGroupId);
  }
}
